import GeneratedQueryStore from "./generated/GeneratedQueryStore"

class QueryStore extends GeneratedQueryStore {

}

export const queryStore = new QueryStore()
